<script setup lang="ts">
/* =============================================================
   PLACEHOLDER PAGE
   =============================================================
   Every section that exists in the navigation but has no screen
   yet renders through here, so the shell is fully walkable while
   the real pages get built one by one.

   Replacing one is self-contained: build the real page, swap the
   import in src/router/index.ts, delete nothing else.
   ============================================================= */

import EmptyState from '@/components/ui/EmptyState.vue'
import PageHeader from '@/components/ui/PageHeader.vue'
import Panel from '@/components/ui/Panel.vue'
import type { IconName } from '@/components/icons'
import { useDocumentTitle } from '@/lib/composables/useDocumentTitle'

const props = defineProps<{
  title: string
  description?: string
  icon?: IconName
  /** What this screen will do, shown inside the empty panel. */
  next?: string
}>()

useDocumentTitle(() => props.title)
</script>

<template>
  <PageHeader :title="title" :description="description">
    <template v-if="$slots.actions" #actions><slot name="actions" /></template>
  </PageHeader>

  <Panel>
    <EmptyState
      :icon="icon"
      title="Nothing here yet"
      :description="next ?? 'This screen is part of the shell but has no content yet.'"
    />
  </Panel>
</template>
